import { Route, Routes } from "react-router-dom";
import RateioFluxoRelatorioConsultaScreen from "@/Components/Populados/Financeiro/Titulo/Rateio/Relatorio/RateioFluxoRelatorio/RateioFluxoRelatorioConsultaScreen";
import TelaPermissao from "@/Components/Base/Permissao/TelaPermissao";

import SaldoPeriodoConsultaScreen from "@/Components/Populados/Relatorio/Financeiro/Conta/MovimentacaoSaldoPeriodo/SaldoPeriodoConsultaScreen";
import { RelatorioDeTitulosAcumulados } from "@/Components/Populados/Financeiro/Titulo/Relatorio/Acumulado/Acumulado";
import { RelatorioDeVisaoMensalDosTitulos } from "@/Components/Populados/Financeiro/Titulo/Relatorio/VisaoMensal/VisaoMensal";
import MovimentacaoConsolidadaConsultaScreen from "@/Components/Populados/Financeiro/Titulo/Relatorio/MovimentacaoConsolidada/MovimentacaoConsolidadaConsultaScreen";
import MovimentacaoConciliacaoConsultaScreen from "@/Components/Populados/Relatorio/Financeiro/Conta/MovimentacaoConciliacao/MovimentacaoConciliacaoConsultaScreen";
import { RelatorioDaVisaoGeralDeMovimentacoes } from "@/Components/Populados/Financeiro/Titulo/Relatorio/VisaoGeralDeMovimentacoes/VisaoGeralDeMovimentacoes";
import { EnumTipoConta } from "@/Models/Financeiro/Conta";
import PessoaBloqueioTable from "../Pessoa/PessoaBloqueio/PessoaBloqueioTable";

export default function RelatorioScreen() {
    return (
        <Routes>
            <Route
                path="extrato-bancario"
                element={
                    <TelaPermissao permissoes={["DomainRelatorioFinanceitoContaMovimentacaoSaldoPeriodoListarTodos"]}>
                        <SaldoPeriodoConsultaScreen camposProps={{
                                contaSelectProps : {
                                    filtros : {
                                        codTiposInvalidos : [EnumTipoConta.ADIANTAMENTO_VIAGEM]
                                    }
                                }
                            }}
                        />
                    </TelaPermissao>
                }
            />
            <Route
                path="contas-x-movimentacoes/*"
                element={
                    <TelaPermissao permissoes={["DomainRelatorioMovimentacaoConsolidadaPessoaListarTodos"]}>
                        <MovimentacaoConsolidadaConsultaScreen />
                    </TelaPermissao>
                }
            />
            <Route
                path="/fluxo-rateio/*"
                element={
                    <TelaPermissao permissoes={["DomainFinanceiroRelatorioFluxoRateioListar"]}>
                        <RateioFluxoRelatorioConsultaScreen />
                    </TelaPermissao>
                }
            />
            <Route
                path="/pessoas-bloqueadas"
                element={
                    <PessoaBloqueioTable />
                }
            />
            <Route
                path="/titulos-acumulados/*"
                element={
                    <TelaPermissao permissoes={["DomainFinanceiroRelatorio_TitulosAcumulados_Listar"]}>
                        <RelatorioDeTitulosAcumulados />
                    </TelaPermissao>
                }
            />
            <Route
                path="/visao-geral-movimentacoes"
                element={
                    <TelaPermissao permissoes={["DomainFinanceiroRelatorio_VisaoGeralDeMovimentacoes_Listar"]}>
                        <RelatorioDaVisaoGeralDeMovimentacoes />
                    </TelaPermissao>
                }
            />
            <Route
                path="/visao-mensal/*"
                element={
                    <TelaPermissao permissoes={["DomainFinanceiroRelatorio_VisaoMensal_Listar"]}>
                        <RelatorioDeVisaoMensalDosTitulos />
                    </TelaPermissao>
                }
            />
        </Routes>
    );
}
